export default class ServerSocket {
    websocket: any
    screenId: string
    url: string
    token: string
    socket_open: boolean
    hearbeat_timer: any             // 心跳timer
    hearbeat_interval: number       // 心跳发送频率
    is_reonnect: boolean
    reconnect_count: number
    reconnect_current: number       // 已发起重连次数
    ronnect_number: number          // 网络错误提示此时
    reconnect_timer: any
    reconnect_interval?: number
    receiveMessage?: Function | null
    constructor(url:string,token?:string){
        this.url = url
        this.token = token
        this.screenId = ""
        this.socket_open = false
        this.hearbeat_interval = 5000
        this.is_reonnect = false
        this.reconnect_count = 3
        this.reconnect_current = 1
        this.ronnect_number = 0
    }
    init (screenId: string,receiveMessage: Function | null, url?:string,):void{
        const that = this
        if (url) {
            this.url = url
        }
        this.screenId = screenId
        this.receiveMessage = receiveMessage
        this.websocket = new WebSocket(this.url+"?screenId="+screenId)
        this.websocket.onmessage = (e: any) => {
            if (receiveMessage) {
                receiveMessage(e)
            }
        }
        this.websocket.onclose = (e: any) => {
            clearInterval(this.hearbeat_interval)
            this.socket_open = false
            // 需要重新连接
            if (this.is_reonnect) {
                this.reconnect_timer = setTimeout(() => {
                    // 超过重连次数
                    if (this.reconnect_current > this.reconnect_count) {
                        clearTimeout(this.reconnect_timer)
                        this.is_reonnect = false
                        return
                    }
                    // 记录重连次数
                    this.reconnect_current++
                    this.reconnect()
                }, this.reconnect_interval)
            }
            console.warn("断开连接")
        }
        // 连接成功
        this.websocket.onopen = function() {
            this.socket_open = true
            this.is_reonnect = true
            // 发送上线通知
            that.send("ONLINE")
            // 开启心跳
            that.heartbeat()
            console.info("连接成功")
        }
        // 连接发生错误
        this.websocket.onerror = function() {
            console.error("websocket 连接错误")
        }
    }
    send(data:any, callback: Function | null = null) {
        // 开启状态直接发送
        if (this.websocket.readyState === this.websocket.OPEN) {
            if (this.screenId && this.screenId !== "") {
                this.websocket.send(JSON.stringify(this.screenId+data))
                if (callback) {
                    callback()
                }
            }
            // 正在开启状态，则等待1s后重新调用
        } else {
            clearInterval(this.hearbeat_timer)
            if (this.ronnect_number < 1) {
                console.error("发送错误")
            }
            this.ronnect_number++
        }
    }
    heartbeat() {
        if (this.hearbeat_timer) {
            clearInterval(this.hearbeat_timer)
        }
        this.hearbeat_timer = setInterval(() => {
            if (this.websocket.readyState === this.websocket.OPEN) {
                this.send("HEARTCMD")
            }
        }, this.hearbeat_interval)
    }
    close(){
        clearInterval(this.hearbeat_interval)
        this.is_reonnect = false
        this.websocket.close()
    }
    reconnect() {
        if (this.websocket && !this.is_reonnect) {
            this.close()
        }
        this.init(this.screenId, this.receiveMessage || null)
    }
}
